// Angular import
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// 3rd Party imports
import { classToPlain, plainToClass } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Constant imports
import { URLConstants } from '../../../_constants/url-constants';

// Model imports
import { CommunityVendorBaseParametersDto } from '../_models/community-vendor-base-parameters-dto';
import { ManageVendorContractResultDto } from '../_models/manage-vendor-contract-result-dto';
import { UploadInsuranceDocumentParametersDto } from '../_models/upload-insurance-document-parameters-dto';
import { VendorContractBaseParameterDto } from '../_models/vendor-contract-base-parameter-dto';
import { VendorContractEditorResultDto } from '../_models/vendor-contract-editor-result-dto';
import { VendorContractRawDto } from '../_models/vendor-contract-raw-dto';
import { VendorInsuranceBaseParameterDto } from '../_models/vendor-insurance-base-parameter-dto';
import { VendorInsuranceDocumentEditorResultDto } from '../_models/vendor-insurance-document-editor-result-dto';
import { VendorAccountNumberVerifyResultDto } from '../_models/vendor-account-number-verify-result-dto';
import { VendorAccountNumberVerifyParameterDto } from '../_models/vendor-account-number-verify-parameter-dto';

@Injectable({
    providedIn: 'root'
})
export class VendorManagementSharedService {
    constructor(private readonly httpClient: HttpClient) {}

    getInsuranceDocumentEditor(
        params: VendorInsuranceBaseParameterDto
    ): Observable<VendorInsuranceDocumentEditorResultDto> {
        const url = `${URLConstants.ccCommunityVendorBaseApiUrl}/insurance/document/editor${params.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((responseData: any) => plainToClass(VendorInsuranceDocumentEditorResultDto, responseData)));
    }

    uploadInsuranceDocument(params: UploadInsuranceDocumentParametersDto): Observable<any> {
        const url = `${URLConstants.ccCommunityVendorBaseApiUrl}/insurance/document`;
        return this.httpClient.post(url, classToPlain(params));
    }

    getManageVendorContract(params: CommunityVendorBaseParametersDto): Observable<ManageVendorContractResultDto> {
        const url = `${URLConstants.ccCommunityVendorBaseApiUrl}/contracts${params.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((responseData: any) => plainToClass(ManageVendorContractResultDto, responseData)));
    }

    getContractEditor(params: VendorContractBaseParameterDto): Observable<VendorContractEditorResultDto> {
        const url = `${URLConstants.ccCommunityVendorBaseApiUrl}/contract/editor${params.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((responseData: any) => plainToClass(VendorContractEditorResultDto, responseData)));
    }

    updateContract(params: VendorContractRawDto): Observable<any> {
        const url = `${URLConstants.ccCommunityVendorBaseApiUrl}/contract`;
        return this.httpClient.put(url, classToPlain(params));
    }

    addContract(params: VendorContractRawDto): Observable<any> {
        const url = `${URLConstants.ccCommunityVendorBaseApiUrl}/contract`;
        return this.httpClient.post(url, classToPlain(params));
    }

    verifyVendorAccountNumber(
        params: VendorAccountNumberVerifyParameterDto,
        contextUrl: string
    ): Observable<VendorAccountNumberVerifyResultDto> {
        const url = contextUrl;
        return this.httpClient
            .post<VendorAccountNumberVerifyResultDto>(url, classToPlain(params))
            .pipe(map((response: any) => plainToClass(VendorAccountNumberVerifyResultDto, response)));
    }
}
